module.exports = __webpack_public_path__ + "img/電気回路_6_7.69ed77ff.png";